import axios from "axios";
import path from "../../path";
// const token = sessionStorage.getItem("token");

// Create an Axios instance with default headers
const apiClient = axios.create({
  baseURL: path,
  headers: {
    "Content-Type": "application/json",
  },
});

// Helper function to get the auth token
const getAuthToken = () => sessionStorage.getItem("token");

// Add request interceptor to include token in headers
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API functions
export const getAllLeadsApi = async (
  id,
  page,
  rowsPerPage,
  orderBy,
  order,
  activeTab,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/user/get-all-leads/${id}`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        filter: activeTab,
        search: search,
      },
    });
    // console.log("Response:", response);
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getAllTeamApi = async (
  id,
  page,
  rowsPerPage,
  orderBy,
  order,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/user/all-team/${id}`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const updateLeadStatusApi = (id, data, headers) => {
  return axios.put(
    `${path}/v1/user/update-lead-status/${id}`,
    { data },
    headers
  );
};

export const updateProfileApi = async (id, data) => {
  try {
    const response = await apiClient.put(
      `/v1/user/update-profile-info/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const addTeamApi = async (id, data) => {
  try {
    const response = await apiClient.post(`/v1/user/add-team/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const editTeamApi = async (id, data) => {
  try {
    const response = await apiClient.put(`/v1/user/edit-team/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const getUserProfileApi = async (id) => {
  try {
    const response = await apiClient.get(`/v1/user/get-profile-info/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

export const addNotesApi = (leadId, data, headers) => {
  return axios.post(`${path}/v1/user/add-note/${leadId}`, { data }, headers);
};

export const getAllNotesApi = (leadId, headers) => {
  return axios.get(`${path}/v1/user/get-all-notes/${leadId}`, headers);
};

export const deleteNoteApi = (noteId, headers) => {
  return axios.put(`${path}/v1/user/delete-note/${noteId}`, {}, headers);
};

export const updateNotesApi = (noteId, data, headers) => {
  return axios.put(`${path}/v1/user/update-note/${noteId}`, { data }, headers);
};

export const deleteTeamApi = (teamId, headers) => {
  return axios.put(`${path}/v1/user/delete-team/${teamId}`, {}, headers);
};

export const toggleShowReviewApi = (reviewId, headers) => {
  return axios.put(
    `${path}/v1/user/update-show-review/${reviewId}`,
    {},
    headers
  );
};

export const getAllLogsApi = async (
  page,
  rowsPerPage,
  orderBy,
  order,
  search,
  type,
  id = null,
  organizationId = null
) => {
  try {
    const response = await apiClient.get(`/v1/logs/get-logs/`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
        type,
        id,
        organizationId,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getAllLogsProvidersApi = async (search = "") => {
  try {
    const response = await apiClient.get(`/v1/logs/all-provider`, {
      params: {
        search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching providers:", error);
    throw error;
  }
};

export const getFormSortLogsApi = async (page, limit, search) => {

  try {
    const response = await apiClient.get(`/v1/logs/get-formsort-logs/`, {
      params: {
        page: Number(page) + 1,
        limit: Number(limit),
        search: search || ""
      }
    });

    return response;
  } catch (error) {
    console.error("Error fetching logs:", error);
    throw error;
  }
};
export const getAllNotificationApi = async (role) => {
  try {
    const response = await apiClient.get(
      `/v1/notification/get-notification-list/`,
      {
        params: {
          role,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const markAllReadNotificationApi = async (role) => {
  try {
    const response = await apiClient.get(`/v1/notification/mark-all-read`);
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const updateNotificationApi = async (id) => {
  try {
    const response = await apiClient.put(
      `/v1/notification/update-status/${id}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const getNotificationLogsApi = async (
  page,
  rowsPerPage,
  role,
  search
) => {
  try {
    const response = await apiClient.get(
      `/v1/notification/notification-list/`,
      {
        params: {
          page: page + 1,
          limit: rowsPerPage,
          role,
          search: search,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

// CSV/Blob downloads with auth
export const exportLeadsCsvApi = async (encryptedData) => {
  try {
    const response = await apiClient.get(`/v1/lead/csv-export`, {
      params: { data: encryptedData },
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    console.error('Error exporting leads CSV:', error);
    throw error;
  }
};

export const exportLogsCsvApi = async (encryptedRecords, encryptedId = null) => {
  try {
    const response = await apiClient.get(`/v1/logs/generate-logs`, {
      params: { records: encryptedRecords, id: encryptedId },
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    console.error('Error exporting logs CSV:', error);
    throw error;
  }
};

export const exportNotificationsCsvApi = async (encryptedData, role) => {
  try {
    const response = await apiClient.get(`/v1/notification/download-csv-file`, {
      params: { data: encryptedData, role },
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    console.error('Error exporting notifications CSV:', error);
    throw error;
  }
};

export const getReviewsApi = async (
  id,
  page,
  rowsPerPage,
  orderBy,
  order,
  search
) => {
  try {
    const response = await apiClient.get(`/v1/user/all-reviews/${id}`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        sortBy: orderBy,
        order: order,
        search: search,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw error;
  }
};

export const updatePatientInfoApi = (id, data, headers) => {
  return axios.put(
    `${path}/v1/user/update-patient-info/${id}`,
    { data },
    headers
  );
};

export const getLocationDetails = (id, headers) => {
  return axios.get(`${path}/v1/user/location-details/${id}`, headers);
};

export const addDisplayDataApi = async (data) => {
  try {
    const response = await apiClient.post(
      `/v1/location-display/add-location-data`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const getDocdsplyDetails = (id, headers) => {
  return axios.get(
    `${path}/v1/location-display/location-details/${id}`,
    headers
  );
};
